import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Calificar`

export function insertar(nuevaCalificacion) {
  return http.post(API_ENDPOINT, nuevaCalificacion)
}
